<template>
    <div class="appWrapper">
    <div class="holder">
        <div class="thankyouWrapper">
            <h3>Booking Confirmed   </h3>
            <p>Your booking has been successfully confirmed. Thank you for choosing the Nissan Adventure Club experience.</p>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import { updateSalesforceLead, base_be_url } from '@/utils/api';
import { validateMobile, dietaryOptions } from '@/utils/constants';
import adobeAnalytics from "@/plugin/analytics";

export default {
 
    data() {
        return {
            isFocused: false,
            Title: "",
            Email: "",
            LastName: "",
            FirstName: "", 
            MobilePhone: "",
            Dietary_Requirements__c: "",
            Has_Opted_Out_Of_Marketing_Material__c: true,
            isMobileValid: true,
            isError:false,
            errorMessage: "",
            showThankYouMessage: false,
            dietaryOptions: dietaryOptions,
            selectedDietaryRequirements: [],
            dietaryRequirementsOnSubmit: false,
        };
    },
    methods: {
        fetchData() {
            try {
                const salesForceId = this.$route.query.sales_force_id;
                const apiUrl = `${base_be_url}?sales_force_id=${salesForceId}`;

                axios.get(apiUrl)
                    .then(response => {
                        // Handle the successful response
                        const res = response.data;
                        if (res.success && res.response.totalSize > 0 ) {
                            this.Title = res.response.records[0].Title;
                            this.FirstName = res.response.records[0].FirstName;
                            this.LastName = res.response.records[0].LastName;
                            this.Email = res.response.records[0].Email;
                            this.MobilePhone = res.response.records[0].MobilePhone;
                            this.Has_Opted_Out_Of_Marketing_Material__c = res.response.records[0].Has_Opted_Out_Of_Marketing_Material__c;
                            if(res.response.records[0].Dietary_Requirements__c)
                            this.selectedDietaryRequirements = res.response.records[0].Dietary_Requirements__c.split(', ')

                            this.formSubmit()
                            // Adobe Analytics Starts
                        }
                        else{
                            this.$router.push(`/`);
                        }
                    })
            } catch (error) {
                this.$router.push(`/`);

                console.log('ower not found');
            }
        },
        async formSubmit() {
            this.errorMessage = "";
            this.isError = false;
            this.isMobileValid = validateMobile(this.MobilePhone);

            // if (!this.isMobileValid) {
            //     console.log('Invalid mobile number');
            //     return;
            // }

            this.dietaryRequirementsOnSubmit = true;
            if(this.selectedDietaryRequirements.length < 1) {
              return false;
            } 
            const postData = {
                Title: this.Title,
                Email: this.Email,
                Lastname: this.LastName,
                Firstname: this.FirstName,
                MobilePhone: this.MobilePhone,
                Dietary_Requirements__c: this.selectedDietaryRequirements.join(', '),
                Has_Opted_Out_Of_Marketing_Material__c: this.Has_Opted_Out_Of_Marketing_Material__c,
                'owner': false,
                status: "Confirmed"
            };

            try {
                const salesForceId = this.$route.query.sales_force_id;
                const response = await updateSalesforceLead(`${base_be_url}?lead_id=${salesForceId}`, postData);
                // Handle the successful response
                
                if(response.status == 200) {

                  this.showThankYouMessage = true;
                  // Adobe Analytics Starts
                  let event_happened = "Form Complete | Guest";
                  let events = 'event51';
                  let event_126 = "";
                  let eVar14 = event_happened;
                  // let eVar14 = event_happened + "|" + url

                  adobeAnalytics("R","","","","","EN",event_happened,"","","",event_126,events,"","",eVar14);
                  // Adobe Analytics Ends

                } else {
                  this.errorMessage = response.data.message;
                  this.isError = true;
                  console.error('Error submitting form:', response.data.message);
                }
            } catch (error) {
                this.errorMessage = error;
                this.isError = true;
            }
        },
        onFocus(event) {
          // console.log("Element focused:", event.target.tagName);
          if(this.isFocused === false) {
            if (!event.target.hasAttribute("data-focused")) {
              event.target.setAttribute("data-focused", true);
            }
            this.isFocused = true;
            // Adobe Analytics Starts
            let event_happened = "Form Start";
            let event_126 = "";
            let events = 'event50';
            let eVar14 = event_happened;
            // let eVar14 = event_happened + "|" + url

            adobeAnalytics("R","","","","","EN",event_happened,"","","",event_126,events,"","",eVar14);
            // Adobe Analytics Ends
          }
        }
    },
    mounted() {
        // Fetch data when the component is mounted
        this.fetchData();
        const form = document.getElementById("guestForm");
        if (!form) return; // Ensure the form element exists
        // Get all input, select, checkbox, and radio elements within the form
        const elements = form.querySelectorAll("input, select, checkbox, radio");
        // Add focus event listener to each element
        elements.forEach(element => {
          element.addEventListener("focus", this.onFocus);
        });
    },

};
</script>

<style></style>